import { render } from "./file-blank.svg?vue&type=template&id=3042bffe"
const script = {}
script.render = render

export default script